const firebaseConfig = {
  apiKey: "AIzaSyD98Saw3Z99E7f_PCNjROzqMLJk_mIdG88",
  authDomain: "kiddy-by-nasreen.firebaseapp.com",
  projectId: "kiddy-by-nasreen",
  storageBucket: "kiddy-by-nasreen.appspot.com",
  messagingSenderId: "477928372975",
  appId: "1:477928372975:web:861ce873ae86f2f9bf791a"
};
  export default firebaseConfig;